import React, { memo, useCallback, useEffect } from 'react';
import Input from 'components/input';
import Button from 'components/button';
import Toggle from 'components/toggle';
import {
  SET_NOTIFICATION_INTERVAL,
  TOGGLE_DARK_MODE,
} from 'reducers/settingsReducer';
import { useStateValue, useDispatch } from 'state/contextState';
import { lf } from 'storage/localForage';
import notification from 'components/notification';
import styled, { css } from 'styled-components';
import { StyledInput } from 'components/input/styledInput';

const Settings = () => {
  const state = useStateValue('settings');
  const dispatch = useDispatch();

  useEffect(() => {
    lf.setItem('settings', state);
  }, [state]);

  const memoIntervalChange = useCallback((e) => {
    dispatch({ type: SET_NOTIFICATION_INTERVAL, interval: e.target.value });
  }, [dispatch]); // Added dispatch

  const memoToggleDarkMode = useCallback(() => {
    dispatch({ type: TOGGLE_DARK_MODE });
  }, [dispatch]);

  return (
    <SettingsWrapper>
      <SettingsBlock>
        <SettingsRow>
          <SettingsCell>
            <SettingsLabel>Request notification permission</SettingsLabel>
          </SettingsCell>
          <SettingsCell
            $align="center"
          >
            <Button
              type="notification"
              onClick={notification.requestNotificationPermissions}
            />
          </SettingsCell>
        </SettingsRow>
        <SettingsRow>
          <SettingsCell>
            <SettingsLabel>Notify every (minutes)</SettingsLabel>
          </SettingsCell>
          <SettingsCell
            $align="center"
          >
            <InputInterval
              placeholder="minutes"
              handleChange={memoIntervalChange}
              text={state.interval}
            />
          </SettingsCell>
        </SettingsRow>
        <SettingsRow>
          <SettingsCell>
            <SettingsLabel>Dark Mode</SettingsLabel>
          </SettingsCell>
          <SettingsCell
            $align="center"
          >
            <Toggle
              state={!!state.isDarkMode}
              handleToggle={memoToggleDarkMode}
            />
          </SettingsCell>
        </SettingsRow>
      </SettingsBlock>
    </SettingsWrapper>
  );
};

const SettingsWrapper = styled.div`
  display: flex;
   @media screen and (max-width: ${(props) => props.theme.media.sm}){
    flex-direction: column;
   }
`;

const SettingsBlock = styled.div`
  margin: 40px;
  width: 350px;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  @media screen and (max-width: ${(props) => props.theme.media.sm}){
    margin: 40px 5% 20px 5%;
    width: 90%;
   }
`;
const SettingsRow = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: 20px;
  height: 48px;
  width: 100%;
  box-sizing: border-box;
`;

const SettingsCell = styled.div`
  flex: 1 1 100%;
  flex-direction: row;
  display: flex;
  align-items: center;
  ${(props) => props.$align === 'center' && css`
    justify-content: center;
`};
  ${(props) => props.$align === 'default' && css`
    justify-content: left;
`};
`;

const SettingsLabel = styled.div`
  font-family: Roboto;
  font-weight: 300;
  color: ${(props) => props.theme.main.fontColor};
  line-height: 1.5em;
`;

const InputInterval = memo(styled(Input)`
  width: 80px;
  ${StyledInput}{
  width: 80px;
  padding: 0 10px 0 10px;
  border-radius: 5px;
  font-size: 16px;
  height: 34px;
  text-align: center;
  }
`);
export default memo(Settings);
